import { useState, useEffect, Fragment } from "react";
import Subtitulo from "../../Textos/Subtitulo";
import { Divider, Grid, Skeleton } from "@mui/material";
import { getQuestionarioFatca } from "../../../api/Cadastro";
import useStyle from "./styles";
import CustomGrid from "../../GridCadastroCustom";
import CampoSimNao from "../../Campos/CampoSimNao";

export default function QuestionarioFatca({
  idCliente,
  setDada,
  idPerfilLimiteOperacional,
  isLoading,
}) {
  const classes = useStyle();

  const [dadosForm, setDadosForm] = useState({});

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const response = await getQuestionarioFatca(
      idCliente,
      idPerfilLimiteOperacional
    );
    setDadosForm(response);
    setDada(response);
  };

  const handleChange = (e) => {
    const newValue = dadosForm.campos.map((c) => {
      if (c.propriedade === e.target.name)
        return { ...c, ["valor"]: e.target.value }; // Mude para e.target.value
      else return c;
    });

    setDadosForm({ ...dadosForm, ["campos"]: newValue });
    setDada({ ...dadosForm, ["campos"]: newValue });
  };

  return (
    <>
      <div className={classes.box}>
        {isLoading ? (
          <Skeleton animation="wave" width={"15%"} height={30} />
        ) : (
          <>
            <Subtitulo
              sx={{ fontSize: 15 }}
              color="primary"
              label="Questionário Fatca"
            />
            <Subtitulo
              sx={{ fontSize: 16, fontWeight: "bold", mb: 2 }}
              color="primary"
              label="- Selecione 'Sim' ou 'Não' para cada pergunta"
            />
          </>
        )}
        <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
          {dadosForm &&
            dadosForm.campos &&
            dadosForm.campos.map((f, i, array) => (
              <Fragment key={i}>
                <CustomGrid index={i} array={array} md={6}>
                  {isLoading ? (
                    <Skeleton animation="wave" width={"100%"} height={55} />
                  ) : (
                    <CampoSimNao
                      key={i}
                      name={f.propriedade}
                      value={f.valor}
                      handleChange={handleChange}
                      descricao={f.label}
                      enable={true}
                      required={f.obrigatorio}
                      fullWidth={true}
                    />
                  )}
                </CustomGrid>
              </Fragment>
            ))}
        </Grid>
      </div>
    </>
  );
}